import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-social-starter-petition-angles',
		path: '/admin/create_petition_angles',
		component: loadable(
			async () => import(/* webpackChunkName: "pages/admin_social_starter_petition_angles" */ './index'),
			{
				exportName: 'AdminSocialStarterPetitionAngles',
				fallback: Loading,
			},
		),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		frame: true,
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
